// @flow

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getDao } from '../../services/dao';
import Dao from './dao';
import { User } from '../../models/user';

export type Props = {
  dao: any,
  getDao: () => void,
  user: User,
};

const mapState = ({ dao, authentication }) => ({
  dao,
  user: authentication.user,
});

const mapDispatch = { getDao };

export default withRouter(
  connect(
    mapState,
    mapDispatch,
  )(Dao),
);
